







import { DashboardTile } from '@/utils/DashboardUtils';
import ResourceUtils, { Bookshelf } from '@/utils/ResourceUtils';
import { TileAPIParams, TileBookshelfOptions } from '@/utils/TileUtils';
import BookshelfDisplayVue from '@/components/resource/BookshelfDisplay.vue';
import mixins from 'vue-typed-mixins';
export default mixins().extend({
  components: {
    BookshelfDisplay: BookshelfDisplayVue,
  },

  props: {
    tile: {
      type: Object as () => DashboardTile<TileBookshelfOptions>,
    },

    params: {
      type: Object as () => TileAPIParams,
    },
  },

  data(): {
    data?: Bookshelf;
  } {
    return {
      data: undefined,
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      if (this.tile.options.bookshelf?.id) {
        try {
          this.data = undefined;
          this.$alert.hide('load');
          this.data = await ResourceUtils.api.bookshelf.get(
            this.tile.options.bookshelf?.id
          );
        } catch (error) {
          this.$alert.show('load', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },
});
